import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageIntro from './PageIntro';

export interface ConditionItem { icon: string; title: string; text: string }

const ConditionPage: React.FC<{ eyebrow: string; title: React.ReactNode; docTitle: string; lede: string; items: ConditionItem[] }> = ({ eyebrow, title, docTitle, lede, items }) => {
  useEffect(() => { document.title = docTitle; }, [docTitle]);
  return (
    <main>
      <PageIntro eyebrow={eyebrow} title={title} lede={lede} />
      <section className="section">
        <div className="wrap">
          <div className="eyebrow">Where the inbox earns its keep</div>
          <div className="grid grid--2">
            {items.map((it) => (
              <div className="card" key={it.title}>
                <div className="card__ico">{it.icon}</div>
                <h3>{it.title}</h3>
                <p>{it.text}</p>
              </div>
            ))}
          </div>
          <div className="center" style={{ marginTop: '3rem' }}>
            <Link to="/contact" className="btn btn--accent">Get an advocate, free <span className="arrow">→</span></Link>
            <p className="hero__note">Free, voluntary, and not a substitute for your clinicians.</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ConditionPage;
